@if (!shouldSeparateFinal && tabType === 'singleLine') {
  <mat-list class="!flex" [ngClass]="{ '!flex-row': layout === 'row', '!flex-col': layout === 'col' }">
    @for (tab of tabsConfig; track tab.label) {
      <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -- We need to be able to modify this directly -->
      <mat-list-item [style.width]="tabWidth" [class.active]="tab.isActive">
        <button
          type="button"
          matRipple
          matRippleColor="tabsRippleColor"
          class="hover"
          [class.text-left]="layout === 'col'"
          (click)="setActive(tab, tabsConfig)"
        >
          {{ tab.label }}
        </button>
      </mat-list-item>
    }
  </mat-list>
}

@if (shouldSeparateFinal) {
  <mat-list
    class="!flex h-14 !flex-row"
    [ngClass]="{ 'lots-of-tabs': tabsConfig.length >= 8, 'too-many-tabs': tabsConfig.length >= 12 }"
  >
    @for (tab of tabsConfig; track tab.label) {
      @if (!$last) {
        <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -- We need to be able to modify this directly -->
        <mat-list-item class="max-w-52" [style.width]="tabWidth" [class.active]="tab.isActive">
          <button
            type="button"
            matRipple
            matRippleColor="tabsRippleColor"
            class="hover truncate text-start"
            matTooltipPosition="below"
            [matTooltip]="tab.label"
            (click)="setActive(tab, tabsConfig)"
          >
            {{ tab.label }}
          </button>
        </mat-list-item>
      } @else {
        <span class="flex-1 px-4"></span>
        <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -- We need to be able to modify this directly -->
        <mat-list-item
          class="final-tab"
          [style.min-width]="finalTabWidth || tabWidth"
          [style.width]="finalTabWidth || tabWidth"
          [class.active]="finalTab.isActive"
        >
          <button
            type="button"
            class="hover text-center"
            matRipple
            matRippleColor="tabsRippleColor"
            (click)="setActive(finalTab, tabsConfig)"
          >
            {{ finalTab.label }}
          </button>
        </mat-list-item>
      }
    }
  </mat-list>
}

@if (tabType === 'multiLine') {
  <mat-list class="!flex" [ngClass]="{ '!flex-row': layout === 'row', '!flex-col': layout === 'col' }">
    @for (tab of horizontalTabsArray; track $index) {
      <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -- We need to be able to modify this directly -->
      <mat-list-item class="border-r border-[#bdbdbd]" [style.width]="tabWidth" [class.active]="tab.isActive">
        <button
          type="button"
          matRipple
          matRippleColor="tabsRippleColor"
          class="hover flex h-full w-full flex-wrap content-start"
          matTooltipPosition="below"
          [ngClass]="{ 'border-l': $first }"
          [matTooltip]="tab.label"
          (click)="setActive(tab, tabsConfig)"
        >
          @if (tab.label2) {
            <p class="w-full self-center text-start text-xl/none font-semibold">
              {{ tab.label2 }}
            </p>
          }
          <div
            class="line-clamp-2 w-full self-center whitespace-pre-line text-start text-[13px]/none font-medium uppercase tracking-wider"
          >
            {{ tab.label }}
          </div>
        </button>
        @if (!tab.shouldHideCloseButton) {
          <button
            type="button"
            aria-label="Close Tab"
            class="!absolute right-0 top-0 !z-50 !h-5 !w-6 !p-0 text-center !text-xl/none hover:bg-gray-400/25 focus:bg-gray-400/25"
            (click)="remove(tab.label2)"
          >
            <mat-icon [inline]="true">close</mat-icon>
          </button>
        }
      </mat-list-item>
    }
  </mat-list>
}
